import gql from 'graphql-tag'

export default gql`query ycmdVoicemailAudioGet($contactId: ID) {
    ycmdVoicemailAudioGet(contactId: $contactId)
}`